import { CommonModule } from '@angular/common';
import { ECalenderNoteType, ICalendarNote } from '../user-calendar.model';
import { Component, computed, input, model, output, Optional, Inject, signal } from '@angular/core';
import { SharedModule } from '../../../../Shared/shared.module';
import { UserCalendarService } from '../user-calendar.service';
import { UtilityService } from '../../../../Services/utility.service';
import { configPatterns } from 'ets-fe-ng-sdk';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'view-user-calendar-note',
  imports: [CommonModule, SharedModule, MatDialogModule],
  templateUrl: './view-user-calendar-note.component.html',
  styleUrl: './view-user-calendar-note.component.scss',
})
export class ViewUserCalendarNoteComponent {
  readonly note = model<ICalendarNote>(null);
  readonly mini = input<boolean>(null);

  readonly done = output<ICalendarNote>();
  readonly edit = output<ICalendarNote>();
  readonly expand = output<ICalendarNote>();

  readonly noteNote = computed(() => this.note().note.repeat(20));
  readonly header = computed(() => this.uS.toTitleCase(this.note()?.eventType));
  readonly link = computed(() => {
    const note = this.note();
    return note?.eventType == ECalenderNoteType.meeting && configPatterns.url.test(note.eventPlace)
      ? note.eventPlace
      : null;
  });
  protected readonly isMatModal = signal(false);
  constructor(
    public service: UserCalendarService,
    public uS: UtilityService,
    @Optional() public dialogRef: MatDialogRef<ViewUserCalendarNoteComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: { note: ICalendarNote },
  ) {
    if (data?.note) {
      this.note.set(data?.note);
      this.isMatModal.set(true);
    }
  }
}
